/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnableUserAccountRequest
 */
export interface EnableUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof EnableUserAccountRequest
     */
    objectId: string;
    /**
     * 
     * @type {string}
     * @memberof EnableUserAccountRequest
     */
    verifiedPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnableUserAccountRequest
     */
    verifiedEmail?: string | null;
}

/**
 * Check if a given object implements the EnableUserAccountRequest interface.
 */
export function instanceOfEnableUserAccountRequest(value: object): value is EnableUserAccountRequest {
    if (!('objectId' in value) || value['objectId'] === undefined) return false;
    return true;
}

export function EnableUserAccountRequestFromJSON(json: any): EnableUserAccountRequest {
    return EnableUserAccountRequestFromJSONTyped(json, false);
}

export function EnableUserAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableUserAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'objectId': json['objectId'],
        'verifiedPhone': json['verifiedPhone'] == null ? undefined : json['verifiedPhone'],
        'verifiedEmail': json['verifiedEmail'] == null ? undefined : json['verifiedEmail'],
    };
}

export function EnableUserAccountRequestToJSON(json: any): EnableUserAccountRequest {
    return EnableUserAccountRequestToJSONTyped(json, false);
}

export function EnableUserAccountRequestToJSONTyped(value?: EnableUserAccountRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectId': value['objectId'],
        'verifiedPhone': value['verifiedPhone'],
        'verifiedEmail': value['verifiedEmail'],
    };
}

